import { axiosInstance } from '../../api';
import axios from 'axios';
const BASE_PATH = '/offer_handling';


//Set Candidate Interview Status API Call
export let submitOffer = async (candidateID, jobTitle, allocation, offerDescription, offerReviewers, packageReference) => {
    try {

        offerDescription = (offerDescription && offerDescription.length > 0) ? offerDescription : null;
        allocation = (allocation && allocation.length > 0) ? allocation : null;
        packageReference = (packageReference && packageReference.length > 0) ? packageReference : null;

        let value = await axiosInstance.post(BASE_PATH + '/prepare_offer', {
            candidate_id: candidateID,
            offer_reviewers: offerReviewers,
            non_sensitive_data_job_title: jobTitle,
            non_sensitive_data_description: offerDescription,
            non_sensitive_data_allocation: allocation,
            non_sensitive_data_package_reference: packageReference,
        })
        return value;
    } catch (error) {
        return error
    }
}

export let editOffer = async (sessionID, jobTitle, allocation, offerDescription, offerReviewers, packageReference) => {
    try {
        offerDescription = (offerDescription && offerDescription.length > 0) ? offerDescription : null;
        allocation = (allocation && allocation.length > 0) ? allocation : null;
        packageReference = (packageReference && packageReference.length > 0) ? packageReference : null;

        let value = await axiosInstance.post(BASE_PATH + '/edit_offer', {
            offer_session_id: sessionID,
            offer_reviewers: offerReviewers,
            non_sensitive_data_job_title: jobTitle,
            non_sensitive_data_description: offerDescription,
            non_sensitive_data_allocation: allocation,
            non_sensitive_data_package_reference: packageReference,
        })
        return value;
    } catch (error) {
        return error
    }
}


//Get All Pipelines API Call
export let getOffersByType = async (state) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/get_offers', {
            offer_session_state: state
        });
        return value
    } catch (error) {
        return error
    }
}

export let markAsOfferSent = async (offer_session) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/mark_as_offer_sent', {
            offer_session_id: offer_session,
        });
        return value
    } catch (error) {
        return error
    }
}

export let markAsCandidateDeclinedOffer = async (offer_session, reason) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/mark_as_candidate_declined_offer', {
            offer_session_id: offer_session,
            reason: reason
        });
        return value
    } catch (error) {
        return error
    }
}

export let markAsOfferRetracted = async (offer_session, reason) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/mark_as_offer_retracted', {
            offer_session_id: offer_session,
            reason: reason
        });
        return value
    } catch (error) {
        return error
    }
}


export let markAsCandidateAcceptedOffer = async (offer_session) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/mark_as_candidate_accepted_offer', {
            offer_session_id: offer_session,
        });
        return value
    } catch (error) {
        return error
    }
}

export let sendOfferToCandidate = async (offer_session_details) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/send_offer_to_candidate', {
            offer_session_id: offer_session_details.offer_session_id,
        });
        return value
    } catch (error) {
        return error
    }
}

export let getPresignedUrlToUploadOfferLetter = async (offer_session_id) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/get_presigned_url_to_upload_offer_letter', {
            offer_session_id: offer_session_id
        })
        return value;
    } catch (error) {
        return error
    }
}

//Upload offer letter to s3 directly API Call
export let uploadOfferLetterToS3 = async (preSignedUrl, getfile) => {
    try {

        let formData = new FormData();
        formData.append('file', getfile);
        let value = await axios.put(preSignedUrl, formData, {
            headers: {
                'Content-Type': getfile.type
            }
        })
        return value;
    } catch (error) {
        return error
    }
}

export let getPresignedUrlToViewOfferLetter = async (offer_session) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/get_presigned_url_to_view_offer_letter', {
            offer_session_id: offer_session
        })
        return value;
    } catch (error) {
        return error
    }
}

export let sendOfferEmail = async (offer_session, email_subject, email_body) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/send_offer_email', {
            offer_session_id: offer_session,
            email_subject: email_subject,
            email_body: email_body
        });
        return value
    } catch (error) {
        return error
    }
}

//Get candidate offer email template wrapper Call
export let getCandidateOfferEmailConfig = async () => {
    try {
        let value = await axiosInstance.get(BASE_PATH + '/get_candidate_offer_email_configs');
        return value;
    } catch (error) {
        return error
    }
}


export let getPresignedUrlToViewCandidateSignedOfferLetter = async (offer_session) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/get_presigned_url_to_view_candidate_signed_offer_letter', {
            offer_session_id: offer_session
        })
        return value;
    } catch (error) {
        return error
    }
}

//Get All Pipelines API Call
export let getFilteredCandidates = async (pipeline_id, is_all) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/get_filtered_candidates', {
            pipeline_id: pipeline_id,
            is_all: is_all
        });
        return value
    } catch (error) {
        return error
    }
}

//Get All Pipelines API Call
export let getPipelinesForFilteredCandidates = async (state) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/get_pipelines_of_filtered_candidates');
        return value
    } catch (error) {
        return error
    }
}

// // Edit offer
// export let editOffer = async (offerSessionID, jobTitle,allocation,offerDescription,offerReviewers,packageReference) => {
//     try {

//         offerDescription = (offerDescription && offerDescription.length>0) ? offerDescription :null;
//         allocation = (allocation && allocation.length>0) ? allocation :null;
//         packageReference = (packageReference && packageReference.length>0) ? packageReference :null;

//         let value = await axiosInstance.post(BASE_PATH + '/prepare_offer', {
//             offer_session_id: offerSessionID,
//             offer_reviewers: offerReviewers,
//             non_sensitive_data_job_title: jobTitle,
//             non_sensitive_data_description: offerDescription,
//             non_sensitive_data_allocation: allocation,
//             non_sensitive_data_package_reference: packageReference,
//         })
//         return value;
//     } catch (error) {
//         return error
//     }
// }